import qz from '../../qz-tray/2.2.4/qz-tray.js';
//import {cert as demo_cert} from '../../qz-tray/certs/demo-certification';
import {cert} from '../../qz-tray/certs/gonelo-certification-20260423';

// 버전비교 라이브러리
import * as semver from 'semver';

import {get_region_labels} from './labels/labels';


/**
 * 로컬 스토리지에저장할 키값 생성
 * @param region_id
 * @returns {string}
 */
export function makeStorageKey(region_id) {
    return `PrinterManager/${region_id}`;
}


/**
 * Qz 관리객체
 *
 */
class QzManager {
    constructor() {
        // qz 접속여부
        this.connected = false;

        // 현재 동작중인 qz-tray 버전
        this.version = null;

        // 현재 버전이 2.1 미만인지여부
        this.under_2_1 = true;

        // qz 인증서 사인관련 설정작업 실행(최초 한번만)
        this.setCertificate();
        this.log('Qz Certificate Set-up Done!');


    }

    /**
     * (프라미스) 버전반환
     * - 커넥트안한경우 커넥트처리함.
     *
     * @returns {Promise<unknown>}
     */
    async getVersion() {
        return this.connect().then(() => {
            return Promise.resolve(this.version);
        });
    }

    /**
     * (프라미스) qz 인증서등록
     *
     * @returns {Promise<unknown>}
     */
    setCertificate() {
        /// Authentication setup ///
        qz.security.setCertificatePromise(function(resolve, reject) {
            //Preferred method - from server
//        fetch("assets/signing/digital-certificate.txt", {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
//          .then(function(data) { data.ok ? resolve(data.text()) : reject(data.text()); });

            //Alternate method 1 - anonymous
//        resolve();  // remove this line in live environment

            //Alternate method 2 - direct
            resolve(cert);
        });
    }

    /**
     * (프라미스) qz 사이닝등록
     *
     * @returns {Promise<unknown>}
     */
    setSigning() {

        let sign_url = "/ext/qz-tray/assets/signing/sign-message-2.2.4.php?request=";
        if (this.under_2_1) {
            sign_url = "/ext/qz-tray/assets/signing/sign-message.php?request=";
            this.log('QZ old version signing...');
        } else {
            // 2.1 이상
            qz.security.setSignatureAlgorithm("SHA512"); // Since 2.1
        }

        qz.security.setSignaturePromise(function(toSign) {

            return function(resolve, reject) {
                //$.ajax("/ext/qz-tray/assets/signing/sign-message-2.2.4.php?request=" + toSign).then(resolve, reject);
                //Preferred method - from server


                fetch(sign_url + toSign, {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
                    .then(function(data) {
                        //console.log(data);
                        data.ok ? resolve(data.text()) : reject(data.text());
                    });

                //Alternate method - unsigned
                //resolve(); // remove this line in live environment
            };
        });

        this.log('Qz Signing Set-up Done!');
    }


    /**
     * (프라미스) qz 커넥트 처리
     * - 이미 접속된경우, 바로 resolve 처리함.
     *
     * @returns {Promise<unknown>}
     */
    connect() {

        return new Promise((resolve, reject) => {
            if (this.connected) {
                resolve();
                return;
            }

            qz.websocket.connect().then((obj) => {
                // 버전가져오기
                return qz.api.getVersion();

            }).then((ver) => {

                this.version = ver;

                // 2.1 미만버전인지 비교
                this.under_2_1 = semver.satisfies(semver.coerce(ver).version, '<2.1');


                // 사이닝 등록
                this.setSigning();

                this.log(ver + ' connected!');
                this.connected = true;

                resolve();

            }).catch((err) => {
                reject(new Error(`QZ-TRAY에 접속할 수 없습니다. (${err.message})`));

            });


        });
    }



    /**
     * console.log 출력
     * @returns void
     */
    log(msg) {
        let logs = [
            {log: `qzManager`, css: "background-color: lime; color: white"},
            {log: ` ${msg}`, css: "color: black"},
        ];

        let expression = '';
        let args = [];
        logs.forEach((log) => {
            expression += `%c${log.log}`;
            args.push(log.css);
        });
        args.unshift(expression);
        console.debug.apply(undefined, args);
    }
}
export const qzManager = new QzManager();

/**
 * 프린터 관리객체
 * - 모든 프린터 관련동작 (qz 등..)을 담당
 * - 각 지역별로 설정을 따로 관리함.
 */
class PrinterManager {
    constructor(region_id) {


        // 지역ID
        this.regionId = region_id;

        // 설정
        this.config = {
            printerName: null,
            labelId: null,
            printType: null,
        };
        this.storageKey = makeStorageKey(region_id);


        // 출력방식 (zpl, pdf)
        this.printType = null;

        // 라벨
        this.label = null;

        // 해당 지역에서 사용가능한 라벨목록 객체
        this.regionLabels = null;

        this.log('created Printer Manager!');

        // 설정 로드
        this.loadConfig();

        // 출력방식 초기작업
        this.initPrintType();

        // 라벨 초기작업
        this.initLabels();
        this.log('라벨 : ' + this.label);


    }

    /**
     * local storage 에서 설정정보 로드
     */
    loadConfig() {
        let config = localStorage.getItem(this.storageKey);
        if (config) {
            this.config = _.merge(this.config, JSON.parse(config));
        }

        this.log(`loaded local storage! (${this.storageKey})`);
    }

    /**
     * local storage 에서 설정정보 저장
     */
    saveConfig() {
        localStorage.setItem(this.storageKey, JSON.stringify(this.config));
        this.log(`saved local storage! (${this.storageKey})`);
    }

    /**
     * local storage 에서 설정정보 삭제
     */
    removeConfig() {
        if (localStorage.getItem(this.storageKey)) {
            localStorage.removeItem(this.storageKey);
            this.log(`removed local storage! (${this.storageKey})`);

        } else {
            this.log(`already clear local storage! (${this.storageKey})`);

        }

    }

    /**
     * 출력방식 초기작업
     * - 설정에 저장된 값 있으면 사용
     * - 없으면 각 지역별 기본값
     */
    initPrintType() {
        // 해당지역의 가능한 출력방식 설정
        let able_types = this.getAblePrintTypes();


        let type = null;

        // 설정값
        if (this.config.printType) {
            type = this.config.printType;
            // 설정값이 지원목록에 있는지
            if (! able_types.includes(type)) {
                type = null;
            }
        }

        // 지역별 기본값처리
        if (! type) {
            type = able_types[0];
        }

        this.printType = type;

    }

    /**
     * 사용가능한 출력방식 반환
     * @returns {*[]}
     */
    getAblePrintTypes() {
        let able_types = [];

        if (this.getPdfAble()) {
            //able_types.push('pdf');
            able_types.push('png');
        }
        if (this.getZplAble()) {
            able_types.push('zpl');
        }

        return able_types;
    }

    /**
     * 현재 지역이 zpl 출력 가능한지역인지 여부반환
     * @returns bool
     */
    getZplAble() {
        // 추후 신규추가되는지역은 zpl 작업안함
        let able_regions = [
            1,
            2,
            3,
            4,
            5,
            //6,
            7,
            8,
            9,
            10,
            13,
        ];

        return able_regions.includes(this.regionId);
    }

    /**
     * 현재 지역이 pdf 출력 가능한지역인지 여부반환
     * @returns bool
     */
    getPdfAble() {
        // 추후 신규추가되는지역은 기본 pdf로 작업
        // pdf를 지원하지 않는 지역ID를 정의
        let notable_regions = [
            1,
            2,
            3,
            4,
            5,
            //6,
            //7, // TASK-142 PNG 추가
            8,
            //9,
            //10,
        ];

        return ! notable_regions.includes(this.regionId);
    }

    /**
     * 출력방식 선택(설정에 저장)
     * @returns {Promise<unknown>}
     */
    usePrintType(type) {
        return new Promise((resolve, reject) => {
            // 사용가능한 출력방식인지 조회
            let able_types = this.getAblePrintTypes();
            if (! able_types.includes(type)) {
                reject(new Error(`사용할 수 없는 출력방식 입니다.`));
                this.log(`usePrintType: 출력방식 사용 불가(${type})`);
            }


            // 설정에 저장
            this.setConfig('printType', type);

            // 현재 정보변경
            this.printType = type;

            resolve(type);
            this.log(`출력방식 선택완료(${type})`);

        });
    }


    /**
     * 라벨 초기작업
     * - 설정에 저장된 라벨이 있으면 사용
     * - 없으면 지역의 기본값으로 지정된 라벨 사용
     */
    initLabels() {
        this.regionLabels = get_region_labels(this.regionId);
        if (! this.regionLabels) {
            return;
        }


        let label = null;

        // 설정값
        if (this.config.labelId) {
            label = this.regionLabels.get_label(this.config.labelId);
        }

        // 지역 기본라벨
        if (! label) {
            label = this.regionLabels.defaultLabel;
        }

        this.label = label;

    }


    /**
     * 전체 라벨 목록
     * @returns {Promise<unknown>}
     */
    findLabels() {
        return new Promise((resolve, reject) => {
            if (! this.regionLabels) {
                reject(new Error(`라벨용지 조회에 실패하였습니다.`));
                this.log('지역 라벨용지 정보를 찾을 수 없습니다.');
            }
            //console.log(this.regionLabels.labels);
            resolve(this.regionLabels.labels);
            this.log(`라벨용지 목록 조회 완료`);

        });

    }

    /**
     * 라벨용지 선택(설정에 저장)
     * @returns {Promise<unknown>}
     */
    useLabel(label_id) {
        return new Promise((resolve, reject) => {
            // 사용가능한 라벨인지 조회
            let label = this.regionLabels.get_label(label_id);
            if (! label) {
                reject(new Error(`사용할 수 없는 라벨용지 입니다.`));
                this.log(`useLabel: 라벨용지 사용 불가(${label_id})`);
            }

            // 설정에 저장
            this.setConfig('labelId', label.id);

            // 현재 라벨정보변경
            this.label = label;

            resolve(label_id);
            this.log(`라벨용지 선택완료(${label_id})`);

        });
    }



    /**
     * 프린터 선택(설정에 저장)
     * @returns {Promise<unknown>}
     */
    usePrinter(name) {

        return this.findPrinter(name).then((found_name) => {
            return new Promise((resolve, reject) => {
                // 설정에 저장
                this.setConfig('printerName', found_name);

                // 라벨정보 변경

                resolve(found_name);
                this.log(`프린터 선택완료(${found_name})`);

            });
        });
    }

    /**
     * 프린터 이름으로 찾기 (1대)
     * @returns {Promise<unknown>}
     */
    findPrinter(name) {
        if (! name) {
            name = this.getPrinterName();
        }
        //console.log(name);

        return qzManager.connect().then(() => {
            return new Promise((resolve, reject) => {
                if (! name) {
                    reject(new Error(`프린터명이 설정되지 않았습니다.`));
                    return;
                }

                this.log(`프린터를 찾는 중... (${name})`);

                qz.printers.find(name).then((found_name) => {

                    resolve(found_name);
                    this.log(`프린터 찾기 정상(${name})`);


                }).catch((err) => {
                    reject(new Error(`프린터를 찾을 수 없습니다. (${name})`));

                });


            });
        });
    }

    /**
     * 전체 프린트 목록
     * @returns {Promise<unknown>}
     */
    findPrinters() {
        return qzManager.connect().then(() => {
            return new Promise((resolve, reject) => {

                qz.printers.find().then((data) => {
                    resolve(data);
                    this.log(`프린터 목록 조회 완료`);

                }).catch((err) => {
                    reject(new Error(`프린터목록 조회에 실패하였습니다.`));
                    this.log(err.message);

                });


            });
        });

    }



    /**
     * qz 설정객체를 생성 (프린트 및 용지설정)
     *
     *
     * @param printer_name
     * @param data (object) qz출력데이터
     *
     * @returns object
     */
    makeQzConfig(printer_name, data) {

        // 프린트데이터 작성시 결정된 config options
        let customConfigOptions = {}
        if (data && data[0] && data[0].customConfigOptions) {
            customConfigOptions = data[0].customConfigOptions;
        }
        let options = Object.assign({}, customConfigOptions, {
            scaleContent: "true",
            colorType: 'grayscale',
            //rotation: 270,
        }, this.label.makeQzConfigOptions());

        return qz.configs.create(printer_name, options);
    }

    /**
     * 프린트
     *
     * @param data (object) qz출력데이터
     *
     * @returns {Promise<unknown>}
     */
    print(data) {
        // 프린터명 설정검사
        if (! this.getPrinterName()) {
            this.log(`인쇄실패: 프린터 미선택`);
            return Promise.reject(new Error(`프린터설정이 올바르지 않습니다.\n[관리 > 프린터설정] 에서 프린터찾기를 실행하세요.`));

            // todo: 프린터 선택모듈 후 다시 프린트 재시도 처리필요함.

        }
        let config = this.makeQzConfig(this.getPrinterName(), data);




        return this.findPrinter(config.printer.name).then(() => {
            //return Promise.reject(new Error('test error'));
            return new Promise((resolve, reject) => {
                qz.print(config, data).then(() => {
                    resolve();
                    this.log(`프린트 완료`);

                }).catch((err) => {
                    reject(err);
                    this.log(err.message);


                });
            });
        });
    }


    /**
     * 현재 선택된 프린터명 반환
     * @returns string
     */
    getPrinterName() {
        return this.config.printerName;
    }

    /**
     * 설정값 변경
     */
    setConfig(key, value) {
        this.config[key] = value;
        this.log(`changed Config {${key}: ${value}}`);

        this.saveConfig();
    }


    /**
     * console.log 출력
     * @returns void
     */
    log(msg) {
        let logs = [
            {log: `printer[regionId: ${this.regionId}]`, css: "background-color: green; color: white"},
            {log: ` ${msg}`, css: "color: black"},
        ];

        let expression = '';
        let args = [];
        logs.forEach((log) => {
            expression += `%c${log.log}`;
            args.push(log.css);
        });
        args.unshift(expression);
        console.debug.apply(undefined, args);
    }

} // end class PrinterManager

const printers = [];




/**
 * 지역ID로 생성
 * @param region_id
 * @returns {PrinterManager}
 */
export function get_printer(region_id) {
    if (! region_id) {
        throw new Error('Invalid Region ID');
    }
    region_id = parseInt(region_id);
    let printer = _.find(printers, {regionId: region_id})
    if (! printer) {
        printer = new PrinterManager(region_id);
        printers.push(printer);
        //console.log(printers);
    }

    return printer;
}

